module.exports = __webpack_public_path__ + "img/11-small.d72b7793.png";